module.exports = __webpack_public_path__ + "img/info-event.723efc88.jpg";